import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  da: {
    nav: {
      home: 'Forside',
      about: 'Om os',
      experiences: 'Oplevelser',
      snorkeling: 'Snorkling',
      diving: 'Dykning',
      boatTrips: 'Bådture til øer (fra 27 €)',
      desertSafari: 'Ørkensafari',
      privateTours: 'Private VIP ture',
      horse: 'Hestetur (25 €)',
      speedboat: 'Speedboat White Island (150 €)',
      safari: 'Safari tur (30 €)',
      superSafari: 'Super safari tur (30 €)',
      bigBoat: 'Stor bådtur (op til 20 pers.)',
      citytour: 'Citytour Hurghada (20 €)',
      planTrip: 'Planlæg din rejse',
      faq: 'FAQ',
      contact: 'Kontakt',
      allExperiences: 'Se alle oplevelser →',
    },
    hero: {
      title: 'Din personlige rejsepartner i Hurghada',
      subtitle: 'Vi kombinerer dansk tryghed og service med ægte lokal egyptisk ekspertise. Oplev Rødehavets smukkeste perler med personlig rådgivning fra start til slut.',
      ctaPlan: 'Planlæg din rejse',
      ctaContact: 'Kontakt os',
      badge: 'Dansk service & lokal ekspertise',
      exploreTours: 'Udforsk ture',
    },
    heroBadges: {
      danishContact: 'Dansktalende kontakt',
      padiGuides: 'Lokale PADI guider',
      hotelPickup: 'Hotel-afhentning inkluderet',
      fixedPrices: 'Faste priser & tryghed',
    },
    heroSearch: {
      experienceLabel: 'Vælg oplevelse',
      experiencePlaceholder: 'Alle oplevelser',
      guestsLabel: 'Antal personer',
      guestsPlaceholder: '2 voksne',
      searchBtn: 'Find Oplevelse',
      popularTag: 'Populære søgninger:',
      person1: '1 person',
      persons2: '2 personer',
      persons34: '3-4 personer',
      persons5plus: '5+ personer',
    },
    whyUs: {
      qualityBadge: 'Kvalitet & Tryghed',
      title: 'Hvorfor vælge Captain Hurghada',
      subtitle: 'Vi skaber trygge, unikke og uforglemmelige ferieoplevelser i Egypten',
      photoTag: 'Rødehavets Perler',
      photoDesc: 'Eksklusive bådture & sandøer',
      expDanishLocal: 'Dansk & lokal ekspertise',
      foundedBy: 'Grundlagt af Nicoline & Ziad',
      topReviewed: 'Topanmeldt i Hurghada',
      items: [
        {
          icon: 'fa-solid fa-compass-drafting',
          title: 'Lokal ekspertise',
          desc: 'Vores egyptiske bagland kender de mest intime koralrev, gemte øer og bedste ørkenruter langt væk fra masseturismen.'
        },
        {
          icon: 'fa-solid fa-shield-heart',
          title: 'Dansk service & tryghed',
          desc: 'Grundlagt af Nicoline og Ziad. Du får direkte personlig kontakt, klare aftaler og fuld gennemsigtighed.'
        },
        {
          icon: 'fa-solid fa-calendar-check',
          title: 'Personlig planlægning',
          desc: 'Ingen standardiserede pakkerejser. Vi lytter til jeres drømme og tilpasser alle detaljer til jeres tempo.'
        },
        {
          icon: 'fa-solid fa-gem',
          title: 'Skræddersyede oplevelser',
          desc: 'Fra private yagtture og hesteture til ørkensafari og byture – alt er tilpasset jeres ønsker, behov og budget.'
        },
        {
          icon: 'fa-solid fa-car-side',
          title: 'Privat hotel-afhentning',
          desc: 'Komfortabel transport i airconditionerede biler direkte til og fra jeres hotel i Hurghada.'
        },
        {
          icon: 'fa-solid fa-comments',
          title: '24/7 personlig support',
          desc: 'Hurtig rådgivning og personlig hjælp før, under og efter turen via WhatsApp og telefon.'
        }
      ]
    },
    destinations: {
      sectionTag: 'Oplev Området',
      title: 'Populære Destinationer',
      subtitle: 'Oplev de mest fantastiske steder i og omkring Hurghada',
      viewDestination: 'Udforsk tur',
      items: [
        {
          name: 'Ø-ture: Orange Bay, Magawish & Paradise',
          tag: 'Krystalklart paradis',
          desc: 'Maks 8 personer ombord. Frokost, drikkevarer og 2 fantastiske snorkelstop inkluderet.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/orangebay.jpeg',
          link: '/oplevelser/baadture'
        },
        {
          name: 'Hurghada Safari & Super Safari',
          tag: 'Action & Solnedgang',
          desc: 'Ørkeneventyr, beduinkultur, solnedgang og kamelridning. Transfer inkluderet.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/buggy-safari.webp',
          link: '/oplevelser/supersafari-hurghada'
        },
        {
          name: 'Speedboat til White Island',
          tag: 'Privat fart & luksus',
          desc: 'Kun 150 € for op til 7 personer fra 09:00-13:00 inkl. frisk frugt og drikkevarer.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/hurghada-speedboat-white-island.jpg',
          link: '/oplevelser/speedboat'
        },
        {
          name: 'Citytour i Hurghada',
          tag: 'Kultur & Shopping',
          desc: 'Sheraton Street, fiskemarked, Al Mina moské og marinaen. 3 timer med guide.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/citytour.jpeg',
          link: '/oplevelser/citytour-hurghada'
        }
      ]
    },
    howItWorks: {
      title: 'Sådan fungerer det',
      subtitle: 'Tre enkle skridt til din drømmeferie i Hurghada',
      step1Title: 'Fortæl om dine ønsker',
      step1Desc: 'Skriv til os via formularen eller Instagram med dine ønsker.',
      step2Title: 'Vi planlægger rejsen',
      step2Desc: 'Vi sammensætter det perfekte program til dit ophold.',
      step3Title: 'Du nyder ferien',
      step3Desc: 'Læn dig tilbage og nyd en uforglemmelig ferie i solen.'
    },
    experiences: {
      sectionTag: 'Udforsk Vores Ture',
      title: 'Populære Oplevelser',
      subtitle: 'Udforsk vores udvalg af ture og udflugter i Hurghada',
      readMore: 'Læs mere',
      fromPrice: 'Pris',
      duration: 'Varighed',
      groupSize: 'Gruppestørrelse',
      viewAll: 'Se alle oplevelser',
      showMore: 'Vis flere oplevelser',
      showLess: 'Vis færre',
      recommended: 'Anbefalet',
      bestseller: 'Bestseller',
      serviceAndSupport: 'Service & Support',
    },
    gallery: {
      title: 'Mærk stemningen i Hurghada',
      subtitle: 'Et kig på vores seneste oplevelser til vands, i ørkenen og i byen',
      clickToEnlarge: 'Klik på et billede for at åbne galleriet'
    },
    reviews: {
      sectionTag: '5-Stjernede Anmeldelser',
      title: 'Det siger vores gæster',
      subtitle: 'Hør hvordan andre rejsende oplevede deres tur med Captain Hurghada Tours',
      prevAria: 'Forrige anmeldelse',
      nextAria: 'Næste anmeldelse',
    },
    ctaBanner: {
      readyBadge: 'Klar til eventyr?',
      title: 'Skal vi hjælpe med din næste ferie?',
      subtitle: 'Skriv til Nicoline & Ziad og holdet i dag – vi glæder os til at byde dig velkommen til Hurghada!',
      button: 'Kontakt os uforpligtende'
    },
    footer: {
      tagline: 'Din personlige rejsepartner i Hurghada. Grundlagt af Nicoline og Ziad. Tryghed, eventyr og luksuriøse oplevelser.',
      followInsta: 'Følg os på Instagram',
      instaSub: 'Se daglige billeder, videoer og historier fra vores ture i Hurghada',
      quickLinks: 'Hurtige links',
      contactInfo: 'Kontaktoplysninger',
      address: 'Hurghada, Rødehavet, Egypten',
      copyright: '© 2026 Captain Hurghada Tours (captainhurgadatours.dk). Alle rettigheder forbeholdes.',
      danishSafety: 'Dansk tryghed',
      localExp: 'Lokal ekspertise'
    },
    contactPage: {
      title: 'Kontakt Captain Hurghada Tours',
      subtitle: 'Har du spørgsmål eller ønsker du at booke en tur? Nicoline & Ziad og holdet sidder klar til at hjælpe dig.',
      directContact: 'Direkte kontakt',
      directSub: 'WhatsApp, telefon eller e-mail',
      phoneText: 'WhatsApp / Telefon',
      emailText: 'E-mailadresse',
      locationText: 'Placering',
      locationVal: 'Hurghada, Rødehavet, Egypten',
      instaCardTitle: 'Skriv direkte på Instagram',
      instaCardDesc: 'Nicoline & Ziad og holdet tjekker beskeder på Instagram @captainhurgada flere gange dagligt.',
      instaBtn: 'Åbn Instagram @captainhurgada',
      formTitle: 'Send os en besked',
      formSub: 'Udfyld formularen, så vender vi hurtigt tilbage med forslag, priser og svar på dine spørgsmål.',
      nameLabel: 'Dit navn',
      namePlaceholder: 'F.eks. Mette Hansen',
      emailLabel: 'Din e-mailadresse',
      emailPlaceholder: 'navn@eksempel.dk',
      phoneLabel: 'Telefonnummer / WhatsApp',
      phonePlaceholder: '+45 12 34 56 78',
      subjectLabel: 'Vælg oplevelse / emne',
      subjectDefault: '-- Vælg en oplevelse (valgfri) --',
      subjects: {
        privateBoat: 'Privat Bådtur & Skræddersyet Sejlads',
        horseTrip: 'Hestetur ved stranden & ørkenen',
        dolphin: 'Dolphin House & Snorkeltur',
        safari: 'Ørkensafari & Quad Bike',
        islandTrip: 'Ø-ture: Magawish / Paradise / Orange Bay / Hula Hula',
        speedboat: 'Speedboat (op til 7 personer)',
        citytour: 'Citytour i Hurghada (3 timer)',
        general: 'Generel rådgivning og feriepakke'
      },
      descLabel: 'Beskriv dine ønsker, ønsket tur, dato og antal personer',
      descPlaceholder: 'Fortæl os om hvornår I skal til Hurghada, hvor mange I er, og hvilke udflugter I drømmer om...',
      fileLabel: 'Vedhæft filer eller billeder (valgfrit)',
      fileFormats: 'PDF, PNG, JPG, WEBP (maks. 5 filer, 10 MB pr. fil)',
      submitBtn: 'Send besked',
      submittingBtn: 'Sender besked...',
      successTitle: 'Tak for din besked!',
      successMsg: 'Mange tak for din henvendelse! Vi vender hurtigt tilbage til dig.',
      sendAnotherBtn: 'Send en ny besked',
      errorMsg: 'Der opstod en fejl under afsendelsen. Prøv venligst igen eller skriv til os på WhatsApp/Instagram.',
      maxFilesAlert: 'Du kan maksimalt vedhæfte 5 filer.'
    },
    aboutPage: {
      heroTitle: 'Dansk Tryghed & Lokal Egypter-Magi',
      heroSubtitle: 'Mød Nicoline og Ziad. Sammen brænder vi for at give dig den mest autentiske, trygge og uforglemmelige ferie i Hurghada.',
      metaTitle: 'Om os - Grundlagt af Nicoline og Ziad',
      metaDesc: 'Historien om Nicoline og Ziad. Captain Hurghada Tours kombinerer personlig tryghed og service med ægte egyptisk lokalkendskab.',
      quote: '"Din tryghed i Egypten er vores højeste prioritet."',
      founderRole: 'Nicoline & Ziad — Grundlæggere',
      foundedBadge: 'Grundlagt af Nicoline og Ziad',
      storyHeading: 'Vores historie 🇪🇬❤️',
      storyP1: 'Captain Hurghada Tours er skabt ud fra vores kærlighed til Egypten og et ønske om at dele de oplevelser, vi selv holder så meget af.',
      storyP2: 'Vi ved, at en ferie ikke kun handler om hotellet eller stranden. Det er de oplevelser, man tager med sig hjem, som ofte bliver til de bedste minder.',
      storyP3: 'Derfor ønsker vi at give jer mere end bare en tur. Vi vil skabe oplevelser, hvor I kan nyde dagen, føle jer trygge og bare være til stede i øjeblikket. Uanset om det er en dag på det smukke Rødehav, en tur gennem ørkenen, en ridetur eller en oplevelse i en af Egyptens mange fantastiske byer.',
      storyP4: 'For os er det vigtigt, at hver tur føles personlig. Vi vil gerne lære vores gæster at kende, lytte til deres ønsker og gøre vores bedste for, at de får lige præcis den oplevelse, de havde håbet på – eller måske endda lidt mere.',
      storyP5: 'Vi ønsker, at I kommer hjem med et smil på læben, en masse gode historier og følelsen af, at I har oplevet noget helt særligt.',
      storyP6: 'For måske glemmer man, hvad man lavede på en bestemt dag på ferien – men man glemmer ikke den følelse, man havde, eller de minder man skabte. ❤️',
      storyP7: 'Det er dét, vi gerne vil give jer. Oplevelser, I vil huske længe efter, I er kommet hjem. 🇪🇬☀️',
      storyP8: 'Velkommen til Captain Hurghada Tours – Nicoline & Ziad.',
      values: {
        passion: 'Ægte Passion',
        safety: '100% Tryghed',
        planning: 'Personlig Rådgivning',
        quality: 'Kvalitet i alle detaljer'
      }
    },
    planTripPage: {
      title: 'Planlæg din rejse til Hurghada',
      subtitle: 'Skræddersyet ferierådgivning til familier, par, grupper og individuelle rejsende.',
      intro: 'Uanset om I søger rolige ø-ture med maks 8 personer, hestetur på stranden, ørkensafari, hurtig speedbåd eller stor privat båd til 20 personer, tilpasser vi alt til jeres ønsker.',
      optionsTitle: 'Hvem rejser du med?',
      requestOffer: 'Indhent skræddersyet tilbud',
      families: 'Familieferie',
      familiesDesc: 'Børnevenlige både, rolige snorkelspots og afslappende dagsudflugter med masser af plads.',
      familiesFeatures: [
        'Børnevenlige både med masser af skygge og komfortable liggestole',
        'Sikre og rolige snorkelspots med redningsveste i alle børnestørrelser',
        'Fleksibel tidsplan der tilpasses børnenes rytme',
        'Mulighed for privat hotel-transfer med barnestole'
      ],
      couples: 'Par & Romantik',
      couplesDesc: 'Private speedbådsture, hesteture i solnedgang og eksklusive ø-ture.',
      couplesFeatures: [
        'Eksklusive private yagtture kun for jer to',
        'Romantisk frokost på dækket med udsigt til krystalklart vand',
        'Uforstyrret svømmetur ved afsides koralrev og sandøer',
        'Solnedgangssejlads og privat champagne/frugtanretning'
      ],
      groups: 'Grupper & Venner',
      groupsDesc: 'Stor bådtur til op til 20 personer, super safari i ørkenen og fartfyldt speedbåd til White Island.',
      groupsFeatures: [
        'Leje af hele skibet for vennegrupper eller storfamilier',
        'Kombinerede ture med både vandsport, snorkling og ørken quad bikes',
        'Skræddersyet catering efter jeres præferencer',
        'Privat minibus-afhentning direkte fra jeres hotel'
      ],
      solo: 'Individuelle rejsende',
      soloDesc: 'Trygge guidede ture med personlig support, hvor du møder andre glade rejsende.',
      soloFeatures: [
        'Dansktalende vejledning og tryg personlig velkomst',
        'Små intime grupper på max 8-12 deltagere',
        'Mulighed for privat certificeret PADI instruktør på dykkerturen',
        'Fleksibel rådgivning om lokale restauranter og oplevelser'
      ]
    },
    experienceDetail: {
      back: 'Tilbage til oplevelser',
      about: 'Om oplevelsen',
      highlights: 'Højdepunkter & Inkluderet',
      photos: 'Billeder fra turen',
      book: 'Book din oplevelse',
      foundedBy: 'Grundlagt af Nicoline & Ziad',
      transferIncluded: 'Transfer inkluderet eller aftales direkte',
      personalSupport: 'Personlig support og vejledning',
      noPrepayment: 'Ingen forudbetaling påkrævet',
      sendInquiry: 'Send forespørgsel',
      writeInsta: 'Skriv på Instagram',
      contactInsta: 'Skriv på Instagram',
      questionsCall: 'Spørgsmål? Ring til os på',
      notFound: 'Oplevelsen blev ikke fundet',
      loading: 'Henter oplevelse...'
    },
    faqPage: {
      title: 'Ofte Stillede Spørgsmål',
      subtitle: 'Find hurtige og klare svar på alt hvad du behøver at vide før din rejse til Hurghada. Har du andre spørgsmål, er du altid velkommen til at skrive til os.',
      notFoundTitle: 'Fandt du ikke svaret på dit spørgsmål?',
      notFoundSub: 'Kontakt os direkte på Instagram @captainhurgada eller via vores kontaktformular. Vi svarer hurtigt!',
    },
    notFoundPage: {
      badge: 'Fejl 404',
      title: 'Siden Blev Ikke Fundet',
      message: 'Siden du leder efter findes desværre ikke eller er flyttet.',
      homeBtn: 'Gå til forsiden',
      expBtn: 'Se oplevelser'
    },
    forbiddenPage: {
      badge: 'Fejl 403',
      title: 'Adgang Nægtet',
      message: 'Du har ikke tilladelse til at tilgå denne side på captainhurgadatours.dk.',
      homeBtn: 'Gå til forsiden'
    }
  },

  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      experiences: 'Experiences',
      snorkeling: 'Snorkeling',
      diving: 'Diving',
      boatTrips: 'Island Boat Trips (from 27 €)',
      desertSafari: 'Desert Safari',
      privateTours: 'Private VIP Tours',
      horse: 'Horseback Riding (25 €)',
      speedboat: 'Speedboat White Island (150 €)',
      safari: 'Safari Tour (30 €)',
      superSafari: 'Super Safari Tour (30 €)',
      bigBoat: 'Large Boat (up to 20 pax)',
      citytour: 'Hurghada City Tour (20 €)',
      planTrip: 'Plan Your Trip',
      faq: 'FAQ',
      contact: 'Contact',
      allExperiences: 'View all experiences →',
    },
    hero: {
      title: 'Your Personal Travel Partner in Hurghada',
      subtitle: 'We combine Scandinavian hospitality and safety with authentic local Egyptian expertise. Experience the finest Red Sea gems with personalized care from start to finish.',
      ctaPlan: 'Plan Your Trip',
      ctaContact: 'Contact Us',
      badge: 'Scandinavian Quality & Local Expertise',
      exploreTours: 'Explore Tours',
    },
    heroBadges: {
      danishContact: 'Danish & English Contact',
      padiGuides: 'Local PADI Guides',
      hotelPickup: 'Hotel Pickup Included',
      fixedPrices: 'Fixed Prices & Safety',
    },
    heroSearch: {
      experienceLabel: 'Select experience',
      experiencePlaceholder: 'All experiences',
      guestsLabel: 'Number of guests',
      guestsPlaceholder: '2 adults',
      searchBtn: 'Find Experience',
      popularTag: 'Popular searches:',
      person1: '1 person',
      persons2: '2 persons',
      persons34: '3-4 persons',
      persons5plus: '5+ persons',
    },
    whyUs: {
      qualityBadge: 'Quality & Peace of Mind',
      title: 'Why Choose Captain Hurghada',
      subtitle: 'We create safe, unique, and unforgettable holiday memories in Egypt',
      photoTag: 'Red Sea Gems',
      photoDesc: 'Exclusive boat trips & sand islands',
      expDanishLocal: 'Scandinavian & local expertise',
      foundedBy: 'Founded by Nicoline & Ziad',
      topReviewed: 'Top Rated in Hurghada',
      items: [
        {
          icon: 'fa-solid fa-compass-drafting',
          title: 'Local Expertise',
          desc: 'Our local crew knows secret reef locations, pristine sand islands, and desert routes far away from mass tourism.'
        },
        {
          icon: 'fa-solid fa-shield-heart',
          title: 'Personal Care & Security',
          desc: 'Founded by Nicoline and Ziad. Enjoy direct personal communication, clear agreements, and complete transparency.'
        },
        {
          icon: 'fa-solid fa-calendar-check',
          title: 'Personalized Planning',
          desc: 'No generic tour templates. We listen to your wishes and tailor every single detail to your pace.'
        },
        {
          icon: 'fa-solid fa-gem',
          title: 'Tailored Experiences',
          desc: 'From island boat trips and horseback riding to desert safaris and city tours – adapted to your budget and wishes.'
        },
        {
          icon: 'fa-solid fa-car-side',
          title: 'Private Hotel Transfers',
          desc: 'Comfortable air-conditioned transportation directly to and from your hotel in Hurghada.'
        },
        {
          icon: 'fa-solid fa-comments',
          title: '24/7 Personal Support',
          desc: 'Fast assistance before, during, and after your excursion via WhatsApp and phone.'
        }
      ]
    },
    destinations: {
      sectionTag: 'Explore The Area',
      title: 'Popular Destinations',
      subtitle: 'Discover the most incredible locations in and around Hurghada',
      viewDestination: 'Explore tour',
      items: [
        {
          name: 'Island Trips: Orange Bay, Magawish & Paradise',
          tag: 'Crystal Clear Paradise',
          desc: 'Max 8 persons onboard. Lunch, beverages, and 2 wonderful snorkeling stops included.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/orangebay.jpeg',
          link: '/oplevelser/baadture'
        },
        {
          name: 'Hurghada Desert Safari & Super Safari',
          tag: 'Action & Sunset',
          desc: 'Desert adventure, Bedouin culture, sunset views, and camel ride. Transfers included.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/buggy-safari.webp',
          link: '/oplevelser/supersafari-hurghada'
        },
        {
          name: 'Speedboat to White Island',
          tag: 'Private Speed & Luxury',
          desc: 'Only 150 € total for up to 7 persons from 09:00-13:00 incl. fresh fruit and drinks.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/hurghada-speedboat-white-island.jpg',
          link: '/oplevelser/speedboat'
        },
        {
          name: 'Hurghada City Tour',
          tag: 'Culture & Shopping',
          desc: 'Sheraton Street, fish market, Al Mina mosque, and the marina. 3 hours with guide.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/citytour.jpeg',
          link: '/oplevelser/citytour-hurghada'
        }
      ]
    },
    howItWorks: {
      title: 'How It Works',
      subtitle: 'Three simple steps to your dream holiday in Hurghada',
      step1Title: 'Tell Us Your Wishes',
      step1Desc: 'Reach out via our form or Instagram with your wishes.',
      step2Title: 'We Design the Itinerary',
      step2Desc: 'We curate the perfect custom itinerary for your stay.',
      step3Title: 'Enjoy Your Vacation',
      step3Desc: 'Sit back and enjoy an unforgettable holiday in the sun.'
    },
    experiences: {
      sectionTag: 'Explore Our Tours',
      title: 'Popular Experiences',
      subtitle: 'Discover our top tours and excursions in Hurghada',
      readMore: 'Read More',
      fromPrice: 'Price',
      duration: 'Duration',
      groupSize: 'Group Size',
      viewAll: 'View All Experiences',
      showMore: 'Show More Experiences',
      showLess: 'Show Fewer',
      recommended: 'Recommended',
      bestseller: 'Bestseller',
      serviceAndSupport: 'Service & Support',
    },
    gallery: {
      title: 'Feel the Vibe of Hurghada',
      subtitle: 'A glimpse of our latest sea adventures, desert safaris, and city tours',
      clickToEnlarge: 'Click any photo to open the interactive gallery'
    },
    reviews: {
      sectionTag: '5-Star Reviews',
      title: 'What Our Guests Say',
      subtitle: 'Hear how fellow travelers experienced their journey with Captain Hurghada Tours',
      prevAria: 'Previous review',
      nextAria: 'Next review',
    },
    ctaBanner: {
      readyBadge: 'Ready for adventure?',
      title: 'Can We Help Plan Your Next Holiday?',
      subtitle: 'Reach out to Nicoline & Ziad and our team today – we look forward to welcoming you to Hurghada!',
      button: 'Get In Touch'
    },
    footer: {
      tagline: 'Your personal travel partner in Hurghada. Founded by Nicoline and Ziad. Safety, adventure, and bespoke luxury experiences.',
      followInsta: 'Follow Us on Instagram',
      instaSub: 'Check daily photos, stories, and videos from our trips in Hurghada',
      quickLinks: 'Quick Links',
      contactInfo: 'Contact Details',
      address: 'Hurghada, Red Sea, Egypt',
      copyright: '© 2026 Captain Hurghada Tours (captainhurgadatours.dk). All rights reserved.',
      danishSafety: 'Scandinavian Safety',
      localExp: 'Local Expertise'
    },
    contactPage: {
      title: 'Contact Captain Hurghada Tours',
      subtitle: 'Have questions or want to book a tour? Nicoline & Ziad and the team are ready to assist you.',
      directContact: 'Direct Contact',
      directSub: 'WhatsApp, phone or email',
      phoneText: 'WhatsApp / Phone',
      emailText: 'Email Address',
      locationText: 'Location',
      locationVal: 'Hurghada, Red Sea, Egypt',
      instaCardTitle: 'Message us on Instagram',
      instaCardDesc: 'Nicoline & Ziad and the crew check Instagram @captainhurgada messages multiple times a day.',
      instaBtn: 'Open Instagram @captainhurgada',
      formTitle: 'Send Us a Message',
      formSub: 'Fill out the form below and we will get back to you swiftly with custom offers and answers.',
      nameLabel: 'Your Name',
      namePlaceholder: 'e.g. John Smith',
      emailLabel: 'Your Email Address',
      emailPlaceholder: 'name@example.com',
      phoneLabel: 'Phone / WhatsApp',
      phonePlaceholder: '+44 7123 456789',
      subjectLabel: 'Select experience / subject',
      subjectDefault: '-- Select an experience (optional) --',
      subjects: {
        privateBoat: 'Private Boat Charter & Custom Sailing',
        horseTrip: 'Horse Riding on the Beach & Desert',
        dolphin: 'Dolphin House & Snorkeling Trip',
        safari: 'Desert Safari & Quad Biking',
        islandTrip: 'Island Trips: Magawish / Paradise / Orange Bay / Hula Hula',
        speedboat: 'Speedboat (up to 7 persons)',
        citytour: 'City Tour in Hurghada (3 hours)',
        general: 'General inquiry & holiday package'
      },
      descLabel: 'Describe your wishes, preferred tour, date, and number of guests',
      descPlaceholder: 'Tell us when you are visiting Hurghada, how many guests you are, and which tours you are interested in...',
      fileLabel: 'Attach files or photos (optional)',
      fileFormats: 'PDF, PNG, JPG, WEBP (max 5 files, 10 MB per file)',
      submitBtn: 'Send Message',
      submittingBtn: 'Sending message...',
      successTitle: 'Thank You for Your Message!',
      successMsg: 'Thank you for reaching out! We will reply to you as soon as possible.',
      sendAnotherBtn: 'Send another message',
      errorMsg: 'An error occurred while sending. Please try again or message us on WhatsApp/Instagram.',
      maxFilesAlert: 'You can attach a maximum of 5 files.'
    },
    aboutPage: {
      heroTitle: 'European Hospitality & Egyptian Magic',
      heroSubtitle: 'Meet Nicoline and Ziad. Together we are passionate about offering you the most authentic, safe, and memorable holiday in Hurghada.',
      metaTitle: 'About Us - Founded by Nicoline and Ziad',
      metaDesc: 'The story of Nicoline and Ziad. Captain Hurghada Tours combines personal care and peace of mind with authentic Egyptian expertise.',
      quote: '"Your safety and happiness in Egypt is our highest priority."',
      founderRole: 'Nicoline & Ziad — Founders',
      foundedBadge: 'Founded by Nicoline and Ziad',
      storyHeading: 'Our Story 🇪🇬❤️',
      storyP1: 'Captain Hurghada Tours was created out of our love for Egypt and a genuine desire to share the experiences we cherish so deeply.',
      storyP2: 'We believe a holiday is about much more than just a hotel or a beach. It is the authentic adventures you bring home that turn into lifelong memories.',
      storyP3: 'That is why we strive to give you far more than just an ordinary tour. We want to craft experiences where you can truly savor the day, feel completely secure, and be present in the moment. Whether cruising the crystal-clear Red Sea, riding through the desert dunes, enjoying horseback rides, or discovering Egypt’s historic cities.',
      storyP4: 'To us, making every single trip feel personal is essential. We love getting to know our guests, listening to their dreams, and going above and beyond so they receive the exact experience they envisioned – or even better.',
      storyP5: 'We want you to return home with a bright smile, great stories to tell, and the feeling of having experienced something truly extraordinary.',
      storyP6: 'Because you might forget the exact schedule of a vacation day – but you never forget the feeling you had or the memories you created. ❤️',
      storyP7: 'That is what we want to offer you. Unforgettable experiences you will cherish long after returning home. 🇪🇬☀️',
      storyP8: 'Welcome to Captain Hurghada Tours – Nicoline & Ziad.',
      values: {
        passion: 'Genuine Passion',
        safety: '100% Peace of Mind',
        planning: 'Personal Planning',
        quality: 'Top Quality in Every Detail'
      }
    },
    planTripPage: {
      title: 'Plan Your Trip to Hurghada',
      subtitle: 'Custom travel planning for families, couples, groups, and solo travelers.',
      intro: 'Whether you seek calm island trips with max 8 guests, horseback riding on the beach, desert safari, speedboat to White Island, or a large private boat for 20 people, we tailor everything for you.',
      optionsTitle: 'Who are you traveling with?',
      requestOffer: 'Request Custom Offer',
      families: 'Family Holidays',
      familiesDesc: 'Child-friendly boats, calm snorkeling spots, and relaxing day trips with plenty of shade and space.',
      familiesFeatures: [
        'Child-friendly boats with shaded areas and sun loungers',
        'Calm snorkeling spots with life jackets in all kids sizes',
        'Flexible schedule adapted to children needs',
        'Private hotel transfer with child seats'
      ],
      couples: 'Couples & Romance',
      couplesDesc: 'Private speedboat rides, sunset horseback riding, and intimate island escapes.',
      couplesFeatures: [
        'Exclusive private yacht charters just for the two of you',
        'Romantic lunch on deck with crystal-clear turquoise views',
        'Undisturbed swimming at secluded reefs and sandbanks',
        'Sunset sailing with private champagne & tropical fruits'
      ],
      groups: 'Groups & Friends',
      groupsDesc: 'Large private boat for up to 20 people, super desert safari, and fast speedboat tours.',
      groupsFeatures: [
        'Full boat charter for groups of friends or extended family',
        'Combined days with water sports, snorkeling, and desert quads',
        'Tailored catering and music setups on board',
        'Private minibus pickup directly from your resort'
      ],
      solo: 'Solo Travelers',
      soloDesc: 'Safe guided trips with personal support where you meet like-minded travelers.',
      soloFeatures: [
        'English/Scandinavian guidance and warm personal welcome',
        'Intimate small groups capped at max 8-12 guests',
        'Option for private certified PADI instructor for dives',
        'Personal recommendations for local restaurants and culture'
      ]
    },
    experienceDetail: {
      back: 'Back to experiences',
      about: 'About the experience',
      highlights: 'Highlights & Included',
      photos: 'Photos from the tour',
      book: 'Book your experience',
      foundedBy: 'Founded by Nicoline & Ziad',
      transferIncluded: 'Hotel transfer included / arranged directly',
      personalSupport: 'Personal support and guidance',
      noPrepayment: 'No prepayment required',
      sendInquiry: 'Send Inquiry',
      writeInsta: 'Message on Instagram',
      contactInsta: 'Message on Instagram',
      questionsCall: 'Questions? Call us at',
      notFound: 'Experience not found',
      loading: 'Loading experience...'
    },
    faqPage: {
      title: 'Frequently Asked Questions',
      subtitle: 'Find quick and clear answers to everything you need to know before traveling to Hurghada. If you have further questions, feel free to contact us anytime.',
      notFoundTitle: 'Did not find the answer you were looking for?',
      notFoundSub: 'Reach out to us directly on Instagram @captainhurgada or through our contact form. We reply fast!',
    },
    notFoundPage: {
      badge: 'Error 404',
      title: 'Page Not Found',
      message: 'The page you are looking for does not exist or has been moved.',
      homeBtn: 'Go to Homepage',
      expBtn: 'Explore Experiences'
    },
    forbiddenPage: {
      badge: 'Error 403',
      title: 'Access Denied',
      message: 'You do not have permission to access this page on captainhurgadatours.dk.',
      homeBtn: 'Go to Homepage'
    }
  },

  de: {
    nav: {
      home: 'Startseite',
      about: 'Über uns',
      experiences: 'Erlebnisse',
      snorkeling: 'Schnorcheln',
      diving: 'Tauchen',
      boatTrips: 'Insel-Bootstouren (ab 27 €)',
      desertSafari: 'Wüstensafari',
      privateTours: 'Private VIP Touren',
      horse: 'Reitausflug (25 €)',
      speedboat: 'Speedboot White Island (150 €)',
      safari: 'Wüstensafari (30 €)',
      superSafari: 'Super Wüstensafari (30 €)',
      bigBoat: 'Große Bootstour (bis 20 Pers.)',
      citytour: 'Stadtrundfahrt Hurghada (20 €)',
      planTrip: 'Reise planen',
      faq: 'FAQ',
      contact: 'Kontakt',
      allExperiences: 'Alle Erlebnisse ansehen →',
    },
    hero: {
      title: 'Ihr persönlicher Reisepartner in Hurghada',
      subtitle: 'Wir verbinden skandinavische Zuverlässigkeit mit echter ägyptischer Gastfreundschaft. Erleben Sie das Rote Meer mit persönlicher Betreuung von Anfang bis Ende.',
      ctaPlan: 'Reise planen',
      ctaContact: 'Kontaktieren Sie uns',
      badge: 'Europäischer Service & lokale Expertise',
      exploreTours: 'Touren entdecken',
    },
    heroBadges: {
      danishContact: 'Deutsch & Dänisch Support',
      padiGuides: 'Lokale PADI Guides',
      hotelPickup: 'Hotel-Transfer inklusive',
      fixedPrices: 'Festpreise & Sicherheit',
    },
    heroSearch: {
      experienceLabel: 'Erlebnis wählen',
      experiencePlaceholder: 'Alle Erlebnisse',
      guestsLabel: 'Anzahl Personen',
      guestsPlaceholder: '2 Erwachsene',
      searchBtn: 'Erlebnis finden',
      popularTag: 'Beliebte Suchen:',
      person1: '1 Person',
      persons2: '2 Personen',
      persons34: '3-4 Personen',
      persons5plus: '5+ Personen',
    },
    whyUs: {
      qualityBadge: 'Qualität & Sicherheit',
      title: 'Warum Captain Hurghada',
      subtitle: 'Wir schaffen sichere, einzigartige und unvergessliche Urlaubserlebnisse in Ägypten',
      photoTag: 'Perlen des Roten Meeres',
      photoDesc: 'Exklusive Bootstouren & Sandinseln',
      expDanishLocal: 'Europäische & lokale Expertise',
      foundedBy: 'Gegründet von Nicoline & Ziad',
      topReviewed: 'Top-bewertet in Hurghada',
      items: [
        {
          icon: 'fa-solid fa-compass-drafting',
          title: 'Lokale Expertise',
          desc: 'Unser Team kennt die schönsten Korallenriffe, einsame Inseln und Wüstenrouten abseits des Massentourismus.'
        },
        {
          icon: 'fa-solid fa-shield-heart',
          title: 'Persönliche Sicherheit & Service',
          desc: 'Gegründet von Nicoline und Ziad. Direkter persönlicher Kontakt, klare Absprachen und 100% Transparenz.'
        },
        {
          icon: 'fa-solid fa-calendar-check',
          title: 'Individuelle Planung',
          desc: 'Keine standardisierten Massenreisen. Wir hören auf Ihre Wünsche und passen jedes Detail an.'
        },
        {
          icon: 'fa-solid fa-gem',
          title: 'Maßgeschneiderte Erlebnisse',
          desc: 'Von kleinen Inselbootstouren und Reitausflügen bis zu Wüstensafaris und Stadtrundfahrten.'
        },
        {
          icon: 'fa-solid fa-car-side',
          title: 'Privater Hoteltransfer',
          desc: 'Bequemer Transfer in klimatisierten Fahrzeugen direkt von und zu Ihrem Hotel in Hurghada.'
        },
        {
          icon: 'fa-solid fa-comments',
          title: '24/7 Persönliche Betreuung',
          desc: 'Schnelle Unterstützung vor, während und nach Ihrer Tour via WhatsApp und Telefon.'
        }
      ]
    },
    destinations: {
      sectionTag: 'Region Entdecken',
      title: 'Beliebte Destinationen',
      subtitle: 'Entdecken Sie die schönsten Orte in und um Hurghada',
      viewDestination: 'Tour ansehen',
      items: [
        {
          name: 'Insel-Touren: Orange Bay, Magawish & Paradise',
          tag: 'Kristallklares Paradies',
          desc: 'Max. 8 Personen an Bord. Mittagessen, Getränke und 2 Schnorchelstopps inklusive.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/orangebay.jpeg',
          link: '/oplevelser/baadture'
        },
        {
          name: 'Hurghada Wüstensafari & Super Safari',
          tag: 'Action & Sonnenuntergang',
          desc: 'Wüstenabenteuer, Beduinendorf, Sonnenuntergang und Kamelreiten. Transfer inklusive.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/buggy-safari.webp',
          link: '/oplevelser/supersafari-hurghada'
        },
        {
          name: 'Speedboot zur White Island',
          tag: 'Privater Fahrspaß & Luxus',
          desc: 'Nur 150 € gesamt für bis zu 7 Personen von 09:00-13:00 inkl. frischem Obst und Getränken.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/hurghada-speedboat-white-island.jpg',
          link: '/oplevelser/speedboat'
        },
        {
          name: 'Stadtrundfahrt in Hurghada',
          tag: 'Kultur & Einkaufen',
          desc: 'Sheraton Street, Fischmarkt, Al Mina Moschee und die Marina. 3 Stunden mit Guide.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/citytour.jpeg',
          link: '/oplevelser/citytour-hurghada'
        }
      ]
    },
    howItWorks: {
      title: 'So funktioniert es',
      subtitle: 'Drei einfache Schritte zu Ihrem Traumurlaub in Hurghada',
      step1Title: 'Wünsche mitteilen',
      step1Desc: 'Schreiben Sie uns über das Formular oder Instagram Ihre Wünsche.',
      step2Title: 'Wir planen Ihre Tour',
      step2Desc: 'Wir stellen das perfekte Reiseprogramm für Sie zusammen.',
      step3Title: 'Urlaub genießen',
      step3Desc: 'Lehnen Sie sich zurück und genießen Sie eine unvergessliche Zeit.'
    },
    experiences: {
      sectionTag: 'Unsere Touren Entdecken',
      title: 'Beliebte Erlebnisse',
      subtitle: 'Entdecken Sie unsere Touren und Ausflüge in Hurghada',
      readMore: 'Mehr erfahren',
      fromPrice: 'Preis',
      duration: 'Dauer',
      groupSize: 'Gruppengröße',
      viewAll: 'Alle Erlebnisse anzeigen',
      showMore: 'Mehr anzeigen',
      showLess: 'Weniger anzeigen',
      recommended: 'Empfohlen',
      bestseller: 'Bestseller',
      serviceAndSupport: 'Service & Betreuung',
    },
    gallery: {
      title: 'Die Atmosphäre Hurghadas',
      subtitle: 'Einblick in unsere Ausflüge auf dem Meer, in der Wüste und in der Stadt',
      clickToEnlarge: 'Klicken Sie auf ein Bild, um die Galerie zu öffnen'
    },
    reviews: {
      sectionTag: '5-Sterne Bewertungen',
      title: 'Gästebewertungen',
      subtitle: 'Erfahrungen unserer Gäste mit Captain Hurghada Tours',
      prevAria: 'Vorherige Bewertung',
      nextAria: 'Nächste Bewertung',
    },
    ctaBanner: {
      readyBadge: 'Bereit für Abenteuer?',
      title: 'Dürfen wir Ihnen bei der Urlaubsplanung helfen?',
      subtitle: 'Schreiben Sie Nicoline & Ziad und unserem Team – wir freuen uns darauf, Sie in Hurghada zu begrüßen!',
      button: 'Unverbindlich anfragen'
    },
    footer: {
      tagline: 'Ihr persönlicher Reisepartner in Hurghada. Gegründet von Nicoline und Ziad. Sicherheit, Abenteuer und erstklassiger Service.',
      followInsta: 'Folgen Sie uns auf Instagram',
      instaSub: 'Tägliche Fotos, Stories und Videos von unseren Ausflügen in Hurghada',
      quickLinks: 'Quick Links',
      contactInfo: 'Kontaktdaten',
      address: 'Hurghada, Rotes Meer, Ägypten',
      copyright: '© 2026 Captain Hurghada Tours (captainhurgadatours.dk). Alle Rechte vorbehalten.',
      danishSafety: 'Skandinavische Sicherheit',
      localExp: 'Lokale Expertise'
    },
    contactPage: {
      title: 'Kontakt zu Captain Hurghada Tours',
      subtitle: 'Haben Sie Fragen oder möchten Sie eine Tour buchen? Nicoline & Ziad und das Team beraten Sie gern.',
      directContact: 'Direkter Kontakt',
      directSub: 'WhatsApp, Telefon oder E-Mail',
      phoneText: 'WhatsApp / Telefon',
      emailText: 'E-Mail-Adresse',
      locationText: 'Standort',
      locationVal: 'Hurghada, Rotes Meer, Ägypten',
      instaCardTitle: 'Direkt auf Instagram schreiben',
      instaCardDesc: 'Nicoline & Ziad und das Team prüfen Nachrichten auf Instagram @captainhurgada mehrmals täglich.',
      instaBtn: 'Instagram @captainhurgada öffnen',
      formTitle: 'Nachricht senden',
      formSub: 'Füllen Sie das Formular aus und wir melden uns zeitnah mit maßgeschneiderten Angeboten.',
      nameLabel: 'Ihr Name',
      namePlaceholder: 'z.B. Anna Müller',
      emailLabel: 'Ihre E-Mail-Adresse',
      emailPlaceholder: 'name@beispiel.de',
      phoneLabel: 'Telefon / WhatsApp',
      phonePlaceholder: '+49 170 1234567',
      subjectLabel: 'Erlebnis / Anliegen wählen',
      subjectDefault: '-- Erlebnis auswählen (optional) --',
      subjects: {
        privateBoat: 'Private Bootstour & Exklusiver Ausflug',
        horseTrip: 'Reitausflug am Strand & in der Wüste',
        dolphin: 'Dolphin House & Schnorcheltour',
        safari: 'Wüstensafari & Quad-Fahrt',
        islandTrip: 'Insel-Touren: Magawish / Paradise / Orange Bay / Hula Hula',
        speedboat: 'Speedboat (bis zu 7 Personen)',
        citytour: 'Citytour in Hurghada (3 Stunden)',
        general: 'Allgemeine Beratung & Urlaubspaket'
      },
      descLabel: 'Beschreiben Sie Ihre Wünsche, Wunschtour, Datum und Personenanzahl',
      descPlaceholder: 'Teilen Sie uns mit, wann Sie in Hurghada sind, wie viele Personen Sie sind und wovon Sie träumen...',
      fileLabel: 'Dateien oder Fotos anhängen (optional)',
      fileFormats: 'PDF, PNG, JPG, WEBP (max. 5 Dateien, 10 MB pro Datei)',
      submitBtn: 'Nachricht senden',
      submittingBtn: 'Wird gesendet...',
      successTitle: 'Vielen Dank für Ihre Nachricht!',
      successMsg: 'Vielen Dank für Ihre Anfrage! Wir melden uns in Kürze bei Ihnen.',
      sendAnotherBtn: 'Neue Nachricht senden',
      errorMsg: 'Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder schreiben Sie uns auf WhatsApp/Instagram.',
      maxFilesAlert: 'Sie können maximal 5 Dateien anhängen.'
    },
    aboutPage: {
      heroTitle: 'Skandinavische Sicherheit & Ägyptische Magie',
      heroSubtitle: 'Lernen Sie Nicoline und Ziad kennen. Gemeinsam schaffen wir authentische, sichere und unvergessliche Urlaubsmomente in Hurghada.',
      metaTitle: 'Über uns - Gegründet von Nicoline und Ziad',
      metaDesc: 'Die Geschichte von Nicoline und Ziad. Captain Hurghada Tours verbindet persönliche Sicherheit und Betreuung mit echter ägyptischer Ortskenntnis.',
      quote: '"Ihre Sicherheit und Zufriedenheit in Ägypten ist unsere oberste Priorität."',
      founderRole: 'Nicoline & Ziad — Gründer',
      foundedBadge: 'Gegründet von Nicoline und Ziad',
      storyHeading: 'Unsere Geschichte 🇪🇬❤️',
      storyP1: 'Captain Hurghada Tours entstand aus unserer tiefen Liebe zu Ägypten und dem Wunsch, die Erlebnisse zu teilen, die uns selbst so sehr am Herzen liegen.',
      storyP2: 'Wir wissen, dass ein Urlaub nicht nur aus Hotel und Strand besteht. Es sind die einzigartigen Erlebnisse, die man mit nach Hause nimmt, die zu den wertvollsten Erinnerungen werden.',
      storyP3: 'Deshalb möchten wir Ihnen mehr als nur eine gewöhnliche Tour bieten. Wir schaffen Momente, in denen Sie den Tag in vollen Zügen genießen, sich rundum sicher fühlen und einfach im Augenblick sein können. Ob auf dem kristallklaren Roten Meer, bei einer Fahrt durch die Wüste, einem Reitausflug oder einem Besuch historischer Städte.',
      storyP4: 'Uns ist es besonders wichtig, dass sich jede Tour persönlich anfühlt. Wir lernen unsere Gäste gern kennen, hören auf ihre Wünsche und tun alles dafür, dass sie genau das Erlebnis bekommen, das sie sich erhofft haben – oder sogar noch ein bisschen mehr.',
      storyP5: 'Unser Ziel ist es, dass Sie mit einem strahlenden Lächeln, wunderbaren Geschichten und dem Gefühl nach Hause zurückkehren, etwas ganz Besonderes erlebt zu haben.',
      storyP6: 'Denn man vergisst vielleicht, was man an einem bestimmten Tag genau getan hat – aber das Gefühl und die geschaffenen Erinnerungen vergisst man nie. ❤️',
      storyP7: 'Genau das möchten wir Ihnen schenken: Momente, an die Sie sich noch lange nach Ihrer Rückkehr erinnern werden. 🇪🇬☀️',
      storyP8: 'Herzlich willkommen bei Captain Hurghada Tours – Nicoline & Ziad.',
      values: {
        passion: 'Echte Leidenschaft',
        safety: '100% Sicherheit',
        planning: 'Persönliche Beratung',
        quality: 'Höchste Qualität im Detail'
      }
    },
    planTripPage: {
      title: 'Planen Sie Ihre Reise nach Hurghada',
      subtitle: 'Individuelle Urlaubsberatung für Familien, Paare, Gruppen und Alleinreisende.',
      intro: 'Ob ruhige Inseltouren mit max. 8 Personen, Reitausflüge am Strand, Wüstensafaris, Speedboote oder ein großes Privatboot für bis zu 20 Personen – wir gestalten alles nach Ihren Wünschen.',
      optionsTitle: 'Mit wem reisen Sie?',
      requestOffer: 'Individuelles Angebot anfordern',
      families: 'Familienurlaub',
      familiesDesc: 'Kinderfreundliche Boote, ruhige Schnorchelspots und entspannte Ausflüge mit viel Platz.',
      familiesFeatures: [
        'Kinderfreundliche Boote mit viel Schatten und Sonnenliegen',
        'Ruhige Schnorchelspots mit Schwimmwesten in allen Kindergrößen',
        'Flexibler Zeitplan, angepasst an den Rhythmus der Familie',
        'Privater Hoteltransfer mit Kindersitzen möglich'
      ],
      couples: 'Paare & Romantik',
      couplesDesc: 'Private Speedbootfahrten, Reitausflüge bei Sonnenuntergang und idyllische Inseln.',
      couplesFeatures: [
        'Exklusive private Yachtfahrten nur für Sie zwei',
        'Romantisches Mittagessen an Deck mit Blick auf türkisfarbenes Wasser',
        'Ungestörtes Schwimmen an einsamen Riffen und Sandbänken',
        'Sonnenuntergangssegeln mit Champagner & Früchteteller'
      ],
      groups: 'Gruppen & Freunde',
      groupsDesc: 'Großes Privatboot für bis zu 20 Personen, Super Wüstensafari und schnelle Speedboote.',
      groupsFeatures: [
        'Miete des gesamten Bootes für Freundesgruppen oder Großfamilien',
        'Kombinierte Ausflüge mit Wassersport, Schnorcheln und Quad-Bikes',
        'Individuelles Catering und Musik an Bord nach Wunsch',
        'Privater Minibus-Transfer direkt von Ihrer Hotelanlage'
      ],
      solo: 'Alleinreisende',
      soloDesc: 'Sichere geführte Touren mit persönlicher Betreuung und netten Begegnungen.',
      soloFeatures: [
        'Deutsch/Englischsprachige Betreuung und herzlicher Empfang',
        'Kleine, persönliche Gruppen mit max. 8-12 Teilnehmern',
        'Option auf einen privaten zertifizierten PADI-Tauchlehrer',
        'Persönliche Tipps für Restaurants und Kultur in Hurghada'
      ]
    },
    experienceDetail: {
      back: 'Zurück zur Übersicht',
      about: 'Über das Erlebnis',
      highlights: 'Highlights & Inbegriffen',
      photos: 'Fotos vom Ausflug',
      book: 'Jetzt buchen',
      foundedBy: 'Gegründet von Nicoline & Ziad',
      transferIncluded: 'Hoteltransfer inklusive / direkte Absprache',
      personalSupport: 'Persönliche Betreuung & Beratung',
      noPrepayment: 'Keine Vorauszahlung erforderlich',
      sendInquiry: 'Anfrage senden',
      writeInsta: 'Auf Instagram schreiben',
      contactInsta: 'Auf Instagram schreiben',
      questionsCall: 'Fragen? Rufen Sie uns an unter',
      notFound: 'Erlebnis nicht gefunden',
      loading: 'Erlebnis wird geladen...'
    },
    faqPage: {
      title: 'Häufig Gestellte Fragen',
      subtitle: 'Finden Sie schnelle Antworten auf alle wichtigen Fragen vor Ihrer Reise nach Hurghada. Bei weiteren Fragen können Sie uns jederzeit schreiben.',
      notFoundTitle: 'Haben Sie die Antwort nicht gefunden?',
      notFoundSub: 'Kontaktieren Sie uns direkt auf Instagram @captainhurgada oder über unser Kontaktformular. Wir antworten schnell!',
    },
    notFoundPage: {
      badge: 'Fehler 404',
      title: 'Seite Nicht Gefunden',
      message: 'Die gesuchte Seite existiert leider nicht oder wurde verschoben.',
      homeBtn: 'Zur Startseite',
      expBtn: 'Erlebnisse ansehen'
    },
    forbiddenPage: {
      badge: 'Fehler 403',
      title: 'Zugriff Verweigert',
      message: 'Sie haben keine Berechtigung, auf diese Seite von captainhurgadatours.dk zuzugreifen.',
      homeBtn: 'Zur Startseite'
    }
  },

  no: {
    nav: {
      home: 'Hjem',
      about: 'Om oss',
      experiences: 'Opplevelser',
      snorkeling: 'Snorkling',
      diving: 'Dykking',
      boatTrips: 'Båtturer til øyer (fra 27 €)',
      desertSafari: 'Ørkensafari',
      privateTours: 'Private VIP turer',
      horse: 'Ridetur (25 €)',
      speedboat: 'Speedbåt White Island (150 €)',
      safari: 'Safaritur (30 €)',
      superSafari: 'Super safaritur (30 €)',
      bigBoat: 'Stor båttur (opptil 20 pers.)',
      citytour: 'Byvandring Hurghada (20 €)',
      planTrip: 'Planlegg reisen',
      faq: 'FAQ',
      contact: 'Kontakt',
      allExperiences: 'Se alle opplevelser →',
    },
    hero: {
      title: 'Din personlige reisepartner i Hurghada',
      subtitle: 'Vi kombinerer skandinavisk trygghet og service med ekte lokal egyptisk ekspertise. Opplev Rødehavets vakreste perler med personlig oppfølging fra start til slutt.',
      ctaPlan: 'Planlegg din reise',
      ctaContact: 'Kontakt oss',
      badge: 'Skandinavisk service & lokal ekspertise',
      exploreTours: 'Utforsk turer',
    },
    heroBadges: {
      danishContact: 'Skandinavisk kontakt',
      padiGuides: 'Lokale PADI-guider',
      hotelPickup: 'Hotelltransport inkludert',
      fixedPrices: 'Faste priser & trygghet',
    },
    heroSearch: {
      experienceLabel: 'Velg opplevelse',
      experiencePlaceholder: 'Alle opplevelser',
      guestsLabel: 'Antall personer',
      guestsPlaceholder: '2 voksne',
      searchBtn: 'Finn Opplevelse',
      popularTag: 'Populære søk:',
      person1: '1 person',
      persons2: '2 personer',
      persons34: '3-4 personer',
      persons5plus: '5+ personer',
    },
    whyUs: {
      qualityBadge: 'Kvalitet & Trygghet',
      title: 'Hvorfor velge Captain Hurghada',
      subtitle: 'Vi skaper trygge, unike og uforglemmelige ferieopplevelser i Egypt',
      photoTag: 'Rødehavets Perler',
      photoDesc: 'Eksklusive båtturer & sandøyer',
      expDanishLocal: 'Skandinavisk & lokal ekspertise',
      foundedBy: 'Grunnlagt av Nicoline & Ziad',
      topReviewed: 'Topprangert i Hurghada',
      items: [
        {
          icon: 'fa-solid fa-compass-drafting',
          title: 'Lokal ekspertise',
          desc: 'Vårt egyptiske team kjenner de mest intime korallrevene, uberørte øyene og beste ørkenrutene langt unna masseturismen.'
        },
        {
          icon: 'fa-solid fa-shield-heart',
          title: 'Trygghet & god service',
          desc: 'Grunnlagt av Nicoline og Ziad. Du får direkte personlig kontakt, klare avtaler og full åpenhet.'
        },
        {
          icon: 'fa-solid fa-calendar-check',
          title: 'Personlig planlegging',
          desc: 'Ingen standardiserte pakketurer. Vi lytter til deres ønsker og tilpasser alle detaljer til deres tempo.'
        },
        {
          icon: 'fa-solid fa-gem',
          title: 'Skreddersydde opplevelser',
          desc: 'Fra private øyturer og rideturer til ørkensafari og byvandring – alt tilpasses deres ønsker og budsjett.'
        },
        {
          icon: 'fa-solid fa-car-side',
          title: 'Privat hotelltransport',
          desc: 'Komfortabel transport i biler med aircondition direkte til og fra hotellet i Hurghada.'
        },
        {
          icon: 'fa-solid fa-comments',
          title: '24/7 personlig support',
          desc: 'Rask veiledning og personlig hjelp før, under og etter turen via WhatsApp og telefon.'
        }
      ]
    },
    destinations: {
      sectionTag: 'Opplev Området',
      title: 'Populære Destinasjoner',
      subtitle: 'Opplev de mest fantastiske stedene i og rundt Hurghada',
      viewDestination: 'Utforsk tur',
      items: [
        {
          name: 'Øyturer: Orange Bay, Magawish & Paradise',
          tag: 'Krystallklart paradis',
          desc: 'Maks 8 personer om bord. Lunsj, drikke og 2 fantastiske snorkelstopp inkludert.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/orangebay.jpeg',
          link: '/oplevelser/baadture'
        },
        {
          name: 'Hurghada Safari & Super Safari',
          tag: 'Action & Solnedgang',
          desc: 'Ørkeneventyr, beduinkultur, solnedgang og kamelridning. Transfer inkludert.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/buggy-safari.webp',
          link: '/oplevelser/supersafari-hurghada'
        },
        {
          name: 'Speedbåt til White Island',
          tag: 'Privat fart & luksus',
          desc: 'Kun 150 € totalt for opptil 7 personer fra 09:00-13:00 inkl. frisk frukt og drikke.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/hurghada-speedboat-white-island.jpg',
          link: '/oplevelser/speedboat'
        },
        {
          name: 'Citytour i Hurghada',
          tag: 'Kultur & Shopping',
          desc: 'Sheraton Street, fiskemarked, Al Mina moské og marinaen. 3 timer med guide.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/citytour.jpeg',
          link: '/oplevelser/citytour-hurghada'
        }
      ]
    },
    howItWorks: {
      title: 'Slik fungerer det',
      subtitle: 'Tre enkle steg til drømmeferien i Hurghada',
      step1Title: 'Fortell om dine ønsker',
      step1Desc: 'Skriv til oss via skjemaet eller Instagram med dine ønsker.',
      step2Title: 'Vi planlegger reisen',
      step2Desc: 'Vi setter sammen det perfekte programmet for oppholdet.',
      step3Title: 'Du nyter ferien',
      step3Desc: 'Len deg tilbake og nyt en uforglemmelig ferie i solen.'
    },
    experiences: {
      sectionTag: 'Utforsk Våre Turer',
      title: 'Populære Opplevelser',
      subtitle: 'Utforsk vårt utvalg av turer og utflukter i Hurghada',
      readMore: 'Les mer',
      fromPrice: 'Pris',
      duration: 'Varighet',
      groupSize: 'Gruppestørrelse',
      viewAll: 'Se alle opplevelser',
      showMore: 'Vis flere opplevelser',
      showLess: 'Vis færre',
      recommended: 'Anbefalt',
      bestseller: 'Bestselger',
      serviceAndSupport: 'Service & Oppfølging',
    },
    gallery: {
      title: 'Kjenn stemningen i Hurghada',
      subtitle: 'Et innblikk i våre siste opplevelser på havet, i ørkenen og i byen',
      clickToEnlarge: 'Klikk på et bilde for å åpne galleriet'
    },
    reviews: {
      sectionTag: '5-Stjerners Omtaler',
      title: 'Dette sier våre gjester',
      subtitle: 'Hør hvordan andre reisende opplevde sin tur med Captain Hurghada Tours',
      prevAria: 'Forrige omtale',
      nextAria: 'Neste omtale',
    },
    ctaBanner: {
      readyBadge: 'Klar for eventyr?',
      title: 'Skal vi hjelpe med din neste ferie?',
      subtitle: 'Skriv til Nicoline & Ziad og teamet i dag – vi gleder oss til å ønske deg velkommen til Hurghada!',
      button: 'Kontakt oss uforpliktende'
    },
    footer: {
      tagline: 'Din personlige reisepartner i Hurghada. Grunnlagt av Nicoline og Ziad. Trygghet, eventyr og eksklusive opplevelser.',
      followInsta: 'Følg oss på Instagram',
      instaSub: 'Se daglige bilder, videoer og historier fra våre turer i Hurghada',
      quickLinks: 'Hurtiglenker',
      contactInfo: 'Kontaktinformasjon',
      address: 'Hurghada, Rødehavet, Egypt',
      copyright: '© 2026 Captain Hurghada Tours (captainhurgadatours.dk). Alle rettigheter forbeholdt.',
      danishSafety: 'Skandinavisk trygghet',
      localExp: 'Lokal ekspertise'
    },
    contactPage: {
      title: 'Kontakt Captain Hurghada Tours',
      subtitle: 'Har du spørsmål eller ønsker du å bestille en tur? Nicoline & Ziad og teamet står klare til å hjelpe deg.',
      directContact: 'Direkte kontakt',
      directSub: 'WhatsApp, telefon eller e-post',
      phoneText: 'WhatsApp / Telefon',
      emailText: 'E-postadresse',
      locationText: 'Plassering',
      locationVal: 'Hurghada, Rødehavet, Egypt',
      instaCardTitle: 'Skriv direkte på Instagram',
      instaCardDesc: 'Nicoline & Ziad og teamet sjekker meldinger på Instagram @captainhurgada flere ganger daglig.',
      instaBtn: 'Åpne Instagram @captainhurgada',
      formTitle: 'Send oss en melding',
      formSub: 'Fyll ut skjemaet nedenfor, så svarer vi raskt med skreddersydde tilbud og svar på spørsmål.',
      nameLabel: 'Ditt navn',
      namePlaceholder: 'F.eks. Kari Nordmann',
      emailLabel: 'Din e-postadresse',
      emailPlaceholder: 'navn@eksempel.no',
      phoneLabel: 'Telefonnummer / WhatsApp',
      phonePlaceholder: '+47 912 34 567',
      subjectLabel: 'Velg opplevelse / emne',
      subjectDefault: '-- Velg en opplevelse (valgfritt) --',
      subjects: {
        privateBoat: 'Privat Båttur & Skreddersydd Seilas',
        horseTrip: 'Ridning på stranden & ørkenen',
        dolphin: 'Dolphin House & Snorkletur',
        safari: 'Ørkensafari & Quad Biking',
        islandTrip: 'Øy-turer: Magawish / Paradise / Orange Bay / Hula Hula',
        speedboat: 'Speedbåt (opptil 7 personer)',
        citytour: 'Citytour i Hurghada (3 timer)',
        general: 'Generell rådgivning og feriepakke'
      },
      descLabel: 'Beskriv dine ønsker, ønsket tur, dato og antall personer',
      descPlaceholder: 'Fortell oss når dere reiser til Hurghada, hvor mange dere er, og hvilke opplevelser dere drømmer om...',
      fileLabel: 'Legg ved filer eller bilder (valgfritt)',
      fileFormats: 'PDF, PNG, JPG, WEBP (maks 5 filer, 10 MB per fil)',
      submitBtn: 'Send melding',
      submittingBtn: 'Sender din melding...',
      successTitle: 'Takk for din melding!',
      successMsg: 'Tusen takk for henvendelsen! Vi svarer deg så raskt som mulig.',
      sendAnotherBtn: 'Send en ny melding',
      errorMsg: 'Det oppstod en feil under sending. Vennligst prøv igjen eller skriv til oss på WhatsApp/Instagram.',
      maxFilesAlert: 'Du kan maksimalt legge ved 5 filer.'
    },
    aboutPage: {
      heroTitle: 'Skandinavisk Trygghet & Egyptisk Magi',
      heroSubtitle: 'Møt Nicoline og Ziad. Sammen brenner vi for å gi deg den mest autentiske, trygge og uforglemmelige ferien i Hurghada.',
      metaTitle: 'Om oss - Grunnlagt av Nicoline og Ziad',
      metaDesc: 'Historien om Nicoline og Ziad. Captain Hurghada Tours kombinerer personlig trygghet og service med ekte egyptisk lokalkunnskap.',
      quote: '"Din trygghet i Egypt er vår høyeste prioritet."',
      founderRole: 'Nicoline & Ziad — Grunnleggere',
      foundedBadge: 'Grunnlagt av Nicoline og Ziad',
      storyHeading: 'Vår historie 🇪🇬❤️',
      storyP1: 'Captain Hurghada Tours ble skapt ut fra vår kjærlighet til Egypt og et ønske om å dele opplevelsene vi selv setter så stor pris på.',
      storyP2: 'Vi vet at en ferie handler om mye mer enn bare hotellet og stranden. Det er de unike opplevelsene man tar med seg hjem som blir til de beste minnene.',
      storyP3: 'Derfor ønsker vi å gi dere mer enn bare en vanlig tur. Vi vil skape opplevelser hvor dere kan nyte dagen til det fulle, føle dere helt trygge og bare være til stede i øyeblikket. Enten det er på det krystallklare Rødehavet, en tur gjennom ørkendynene, en ridetur eller et besøk i historiske byer.',
      storyP4: 'For oss er det avgjørende at hver eneste tur føles personlig. Vi vil bli kjent med gjestene våre, lytte til deres ønsker og gjøre vårt ytterste for at de får akkurat den opplevelsen de håpet på – eller kanskje enda mer.',
      storyP5: 'Vi ønsker at dere reiser hjem med et stort smil om munnen, fantastiske historier å fortelle og følelsen av å ha opplevd noe helt spesielt.',
      storyP6: 'For man glemmer kanskje hva man gjorde på en bestemt feriedag – men følelsen man hadde og minnene man skapte, glemmer man aldri. ❤️',
      storyP7: 'Det er nettopp det vi vil gi dere: Opplevelser dere vil huske lenge etter at dere har kommet hjem. 🇪🇬☀️',
      storyP8: 'Velkommen til Captain Hurghada Tours – Nicoline & Ziad.',
      values: {
        passion: 'Ekte Lidenskap',
        safety: '100% Trygghet',
        planning: 'Personlig Rådgivning',
        quality: 'Kvalitet i alle detaljer'
      }
    },
    planTripPage: {
      title: 'Planlegg din reise til Hurghada',
      subtitle: 'Skreddersydd ferierådgivning for familier, par, grupper og soloreisende.',
      intro: 'Uansett om dere ønsker rolige øyturer med maks 8 personer, ridetur på stranden, ørkensafari, rask speedbåt eller stor privat båt for 20 personer, tilpasser vi alt etter deres ønsker.',
      optionsTitle: 'Hvem reiser du med?',
      requestOffer: 'Få et skreddersydd tilbud',
      families: 'Familieferie',
      familiesDesc: 'Barnevennlige båter, rolige snorkelsteder og avslappende dagsutflukter med rikelig med plass.',
      familiesFeatures: [
        'Barnevennlige båter med rikelig med skygge og solsenger',
        'Rolige snorkelsteder med redningsvester i alle barnestørrelser',
        'Fleksibel tidsplan tilpasset barnas behov og rytme',
        'Mulighet for privat hotelltransport med barneseter'
      ],
      couples: 'Par & Romantikk',
      couplesDesc: 'Private speedbåtturer, rideturer i solnedgang og intime øyturer.',
      couplesFeatures: [
        'Eksklusive private båtturer kun for dere to',
        'Romantisk lunsj på dekk med utsikt over krystallklart vann',
        'Uforstyrret bading ved fredelige korallrev og sandøyer',
        'Solnedgangsseilas med privat champagne og fruktfat'
      ],
      groups: 'Grupper & Venner',
      groupsDesc: 'Stor båt for opptil 20 personer, super ørkensafari og fartsfylt speedbåt til White Island.',
      groupsFeatures: [
        'Leie av hele båten for vennegjenger eller storfamilien',
        'Kombinerte dager med vannsport, snorkling og ørken-ATV',
        'Skreddersydd catering og musikk om bord etter ønske',
        'Privat minibuss-henting direkte fra hotellet'
      ],
      solo: 'Soloreisende',
      soloDesc: 'Trygge guidede turer med personlig support der du møter andre hyggelige reisende.',
      soloFeatures: [
        'Skandinavisk/engelsktalende veiledning og varm velkomst',
        'Små intime grupper på maks 8-12 deltakere',
        'Mulighet for privat sertifisert PADI-instruktør',
        'Gode personlige råd om restauranter og lokalliv'
      ]
    },
    experienceDetail: {
      back: 'Tilbake til opplevelser',
      about: 'Om opplevelsen',
      highlights: 'Høydepunkter & Inkludert',
      photos: 'Bilder fra turen',
      book: 'Bestill din opplevelse',
      foundedBy: 'Grunnlagt av Nicoline & Ziad',
      transferIncluded: 'Hotelltransfer inkludert / avtales direkte',
      personalSupport: 'Personlig support og veiledning',
      noPrepayment: 'Ingen forskuddsbetaling kreves',
      sendInquiry: 'Send forespørsel',
      writeInsta: 'Skriv på Instagram',
      contactInsta: 'Skriv på Instagram',
      questionsCall: 'Spørsmål? Ring oss på',
      notFound: 'Opplevelsen ble ikke funnet',
      loading: 'Henter opplevelse...'
    },
    faqPage: {
      title: 'Ofte Stilte Spørsmål',
      subtitle: 'Finn raske og tydelige svar på alt du trenger å vite før din reise til Hurghada. Har du andre spørsmål, er du alltid velkommen til å kontakte oss.',
      notFoundTitle: 'Fant du ikke svaret du lette etter?',
      notFoundSub: 'Kontakt oss direkte på Instagram @captainhurgada eller via vårt kontaktskjema. Vi svarer raskt!',
    },
    notFoundPage: {
      badge: 'Feil 404',
      title: 'Siden Ble Ikke Funnet',
      message: 'Siden du leter etter finnes dessverre ikke eller har blitt flyttet.',
      homeBtn: 'Gå til forsiden',
      expBtn: 'Se opplevelser'
    },
    forbiddenPage: {
      badge: 'Feil 403',
      title: 'Adgang Nektet',
      message: 'Du har ikke tillatelse til å åpne denne siden på captainhurgadatours.dk.',
      homeBtn: 'Gå til forsiden'
    }
  },

  sv: {
    nav: {
      home: 'Hem',
      about: 'Om oss',
      experiences: 'Upplevelser',
      snorkeling: 'Snorkling',
      diving: 'Dykning',
      boatTrips: 'Båtturer till öar (från 27 €)',
      desertSafari: 'Ökensafari',
      privateTours: 'Privata VIP turer',
      horse: 'Ridtur (25 €)',
      speedboat: 'Speedbåt White Island (150 €)',
      safari: 'Safaritur (30 €)',
      superSafari: 'Super safaritur (30 €)',
      bigBoat: 'Stor båttur (upp till 20 pers.)',
      citytour: 'Stadstur Hurghada (20 €)',
      planTrip: 'Planera din resa',
      faq: 'FAQ',
      contact: 'Kontakt',
      allExperiences: 'Se alla upplevelser →',
    },
    hero: {
      title: 'Din personliga resepartner i Hurghada',
      subtitle: 'Vi kombinerar skandinavisk trygghet och service med äkta lokal egyptisk expertis. Upplev Röda havets vackraste pärlor med personlig rådgivning från start till mål.',
      ctaPlan: 'Planera din resa',
      ctaContact: 'Kontakta oss',
      badge: 'Skandinavisk service & lokal expertis',
      exploreTours: 'Utforska turer',
    },
    heroBadges: {
      danishContact: 'Skandinavisk kontakt',
      padiGuides: 'Lokala PADI-guider',
      hotelPickup: 'Hotelltransfer ingår',
      fixedPrices: 'Fasta priser & trygghet',
    },
    heroSearch: {
      experienceLabel: 'Välj upplevelse',
      experiencePlaceholder: 'Alla upplevelser',
      guestsLabel: 'Antal personer',
      guestsPlaceholder: '2 vuxna',
      searchBtn: 'Hitta Upplevelse',
      popularTag: 'Populära sökningar:',
      person1: '1 person',
      persons2: '2 personer',
      persons34: '3-4 personer',
      persons5plus: '5+ personer',
    },
    whyUs: {
      qualityBadge: 'Kvalitet & Trygghet',
      title: 'Varför välja Captain Hurghada',
      subtitle: 'Vi skapar trygga, unika och oförglömliga semesterupplevelser i Egypten',
      photoTag: 'Röda havets Pärlor',
      photoDesc: 'Exklusiva båtturer & sandöar',
      expDanishLocal: 'Skandinavisk & lokal expertis',
      foundedBy: 'Grundat av Nicoline & Ziad',
      topReviewed: 'Topprankat i Hurghada',
      items: [
        {
          icon: 'fa-solid fa-compass-drafting',
          title: 'Lokal expertis',
          desc: 'Vårt egyptiska team känner till de mest intressanta korallreven, orörda öarna och bästa ökenrutterna långt bortom massturismen.'
        },
        {
          icon: 'fa-solid fa-shield-heart',
          title: 'Trygghet & service',
          desc: 'Grundat av Nicoline och Ziad. Du får direkt personlig kontakt, tydliga avtal och full transparens.'
        },
        {
          icon: 'fa-solid fa-calendar-check',
          title: 'Personlig planering',
          desc: 'Inga standardiserade paketresor. Vi lyssnar på era drömmar och anpassar varje detalj i er egen takt.'
        },
        {
          icon: 'fa-solid fa-gem',
          title: 'Skräddarsydda upplevelser',
          desc: 'Från privata ö-turer och ridturer till ökensafari och stadsturer – allt anpassat efter era önskemål och budget.'
        },
        {
          icon: 'fa-solid fa-car-side',
          title: 'Privat hotelltransfer',
          desc: 'Bekväm transport i luftkonditionerade bilar direkt till och från ert hotell i Hurghada.'
        },
        {
          icon: 'fa-solid fa-comments',
          title: '24/7 personlig support',
          desc: 'Snabb rådgivning och personlig hjälp före, under och efter turen via WhatsApp och telefon.'
        }
      ]
    },
    destinations: {
      sectionTag: 'Upptäck Området',
      title: 'Populära Destinationer',
      subtitle: 'Upptäck de mest fantastiska platserna i och omkring Hurghada',
      viewDestination: 'Utforska tur',
      items: [
        {
          name: 'Ö-turer: Orange Bay, Magawish & Paradise',
          tag: 'Kristallklart paradis',
          desc: 'Max 8 personer ombord. Lunch, dryck och 2 underbara snorkelstopp ingår.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/orangebay.jpeg',
          link: '/oplevelser/baadture'
        },
        {
          name: 'Hurghada Ökensafari & Super Safari',
          tag: 'Action & Solnedgång',
          desc: 'Ökenäventyr, beduinkultur, solnedgång och kamelridning. Transfer ingår.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/buggy-safari.webp',
          link: '/oplevelser/supersafari-hurghada'
        },
        {
          name: 'Speedbåt till White Island',
          tag: 'Privat fart & lyx',
          desc: 'Endast 150 € totalt för upp till 7 personer från 09:00-13:00 inkl. färsk frukt och dryck.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/hurghada-speedboat-white-island.jpg',
          link: '/oplevelser/speedboat'
        },
        {
          name: 'Citytour i Hurghada',
          tag: 'Kultur & Shopping',
          desc: 'Sheraton Street, fiskmarknad, Al Mina moské och marinan. 3 timmar med guide.',
          image: 'https://assets.auxodev.dk/assets/086b06dd-92e0-474f-8c57-ea0b72c8dd5a/citytour.jpeg',
          link: '/oplevelser/citytour-hurghada'
        }
      ]
    },
    howItWorks: {
      title: 'Så fungerar det',
      subtitle: 'Tre enkla steg till din drömsemester i Hurghada',
      step1Title: 'Berätta om dina önskemål',
      step1Desc: 'Skriv till oss via formuläret eller Instagram med dina önskemål.',
      step2Title: 'Vi planerar resan',
      step2Desc: 'Vi sätter ihop det perfekta programmet för er vistelse.',
      step3Title: 'Njut av semestern',
      step3Desc: 'Luta dig tillbaka och njut av en oförglömlig semester i solen.'
    },
    experiences: {
      sectionTag: 'Utforska Våra Turer',
      title: 'Populära Upplevelser',
      subtitle: 'Utforska vårt utbud av turer och utflykter i Hurghada',
      readMore: 'Läs mer',
      fromPrice: 'Pris',
      duration: 'Varaktighet',
      groupSize: 'Gruppstorlek',
      viewAll: 'Se alla upplevelser',
      showMore: 'Visa fler upplevelser',
      showLess: 'Visa färre',
      recommended: 'Rekommenderad',
      bestseller: 'Bästsäljare',
      serviceAndSupport: 'Service & Support',
    },
    gallery: {
      title: 'Känn stämningen i Hurghada',
      subtitle: 'En titt på våra senaste upplevelser till havs, i öknen och i staden',
      clickToEnlarge: 'Klicka på en bild för att öppna galleriet'
    },
    reviews: {
      sectionTag: '5-Stjärniga Recensioner',
      title: 'Vad våra gäster säger',
      subtitle: 'Hör hur andra resenärer upplevde sin resa med Captain Hurghada Tours',
      prevAria: 'Föregående recension',
      nextAria: 'Nästa recension',
    },
    ctaBanner: {
      readyBadge: 'Redo för äventyr?',
      title: 'Kan vi hjälpa till med er nästa semester?',
      subtitle: 'Skriv till Nicoline & Ziad och teamet idag – vi ser fram emot att välkomna er till Hurghada!',
      button: 'Kontakta oss förfrågan'
    },
    footer: {
      tagline: 'Er personliga resepartner i Hurghada. Grundat av Nicoline och Ziad. Trygghet, äventyr och exklusiva upplevelser.',
      followInsta: 'Följ oss på Instagram',
      instaSub: 'Se dagliga bilder, videor och berättelser från våra turer i Hurghada',
      quickLinks: 'Snabblänkar',
      contactInfo: 'Kontaktuppgifter',
      address: 'Hurghada, Röda havet, Egypten',
      copyright: '© 2026 Captain Hurghada Tours (captainhurgadatours.dk). Alla rättigheter förbehållna.',
      danishSafety: 'Skandinavisk trygghet',
      localExp: 'Lokal expertis'
    },
    contactPage: {
      title: 'Kontakta Captain Hurghada Tours',
      subtitle: 'Har ni frågor eller vill ni boka en tur? Nicoline & Ziad och teamet finns här för att hjälpa er.',
      directContact: 'Direkt kontakt',
      directSub: 'WhatsApp, telefon eller e-post',
      phoneText: 'WhatsApp / Telefon',
      emailText: 'E-postadress',
      locationText: 'Plats',
      locationVal: 'Hurghada, Röda havet, Egypten',
      instaCardTitle: 'Skriv direkt på Instagram',
      instaCardDesc: 'Nicoline & Ziad och teamet kollar meddelanden på Instagram @captainhurgada flera gånger dagligen.',
      instaBtn: 'Öppna Instagram @captainhurgada',
      formTitle: 'Skicka ett meddelande',
      formSub: 'Fyll i formuläret nedan så återkommer vi snabbt med skräddarsydda förslag och priser.',
      nameLabel: 'Ditt namn',
      namePlaceholder: 'T.ex. Anna Andersson',
      emailLabel: 'Din e-postadress',
      emailPlaceholder: 'namn@exempel.se',
      phoneLabel: 'Telefonnummer / WhatsApp',
      phonePlaceholder: '+46 70 123 45 67',
      subjectLabel: 'Välj upplevelse / ämne',
      subjectDefault: '-- Välj en upplevelse (valfritt) --',
      subjects: {
        privateBoat: 'Privat Båttur & Skräddarsydd Segling',
        horseTrip: 'Ridtur på stranden & i öknen',
        dolphin: 'Dolphin House & Snorkeltur',
        safari: 'Ökensafari & Fyrhjuling',
        islandTrip: 'Ö-turer: Magawish / Paradise / Orange Bay / Hula Hula',
        speedboat: 'Speedbåt (upp till 7 personer)',
        citytour: 'Citytour i Hurghada (3 timmar)',
        general: 'Allmän rådgivning och semesterpaket'
      },
      descLabel: 'Beskriv era önskemål, önskad tur, datum och antal personer',
      descPlaceholder: 'Berätta när ni besöker Hurghada, hur många ni är och vilka turer ni drömmer om...',
      fileLabel: 'Bifoga filer eller bilder (valfritt)',
      fileFormats: 'PDF, PNG, JPG, WEBP (max 5 filer, 10 MB per fil)',
      submitBtn: 'Skicka meddelande',
      submittingBtn: 'Skickar meddelande...',
      successTitle: 'Tack för ert meddelande!',
      successMsg: 'Stort tack för er förfrågan! Vi återkommer till er så snart som möjligt.',
      sendAnotherBtn: 'Skicka ett nytt meddelande',
      errorMsg: 'Ett fel uppstod vid sändningen. Försök igen eller skriv till oss på WhatsApp/Instagram.',
      maxFilesAlert: 'Ni kan maximalt bifoga 5 filer.'
    },
    aboutPage: {
      heroTitle: 'Skandinavisk Trygghet & Egyptisk Magi',
      heroSubtitle: 'Möt Nicoline och Ziad. Tillsammans brinner vi för att ge er den mest autentiska, trygga och oförglömliga semestern i Hurghada.',
      metaTitle: 'Om oss - Grundat av Nicoline och Ziad',
      metaDesc: 'Historien om Nicoline och Ziad. Captain Hurghada Tours kombinerar personlig trygghet och service med äkta egyptisk lokalkännedom.',
      quote: '"Er trygghet i Egypten är vår högsta prioritet."',
      founderRole: 'Nicoline & Ziad — Grundare',
      foundedBadge: 'Grundat av Nicoline och Ziad',
      storyHeading: 'Vår historia 🇪🇬❤️',
      storyP1: 'Captain Hurghada Tours skapades ur vår kärlek till Egypten och en önskan om att dela med oss av de upplevelser vi själva håller så kära.',
      storyP2: 'Vi vet att en semester handlar om mycket mer än bara hotellet och stranden. Det är de genuina upplevelserna man tar med sig hem som blir till de bästa minnena.',
      storyP3: 'Därför vill vi ge er mer än bara en vanlig tur. Vi vill skapa upplevelser där ni kan njuta till fullo av dagen, känna er helt trygga och bara vara närvarande i stunden. Oavsett om det är på det kristallklara Röda havet, en tur genom öknen, en ridtur eller ett besök i någon av Egyptens historiska städer.',
      storyP4: 'För oss är det viktigt att varje tur känns personlig. Vi vill lära känna våra gäster, lyssna på deras önskemål och göra vårt yttersta för att de ska få precis den upplevelse de hoppades på – eller kanske ännu mer.',
      storyP5: 'Vi vill att ni ska komma hem med ett leende på läpparna, fantastiska historier att berätta och känslan av att ha upplevt något alldeles unikt.',
      storyP6: 'För man kanske glömmer vad man gjorde en specifik dag på semestern – men känslan man hade och minnena man skapade glömmer man aldrig. ❤️',
      storyP7: 'Det är just det vi vill ge er: Upplevelser ni kommer att minnas länge efter att ni kommit hem. 🇪🇬☀️',
      storyP8: 'Varmt välkomna till Captain Hurghada Tours – Nicoline & Ziad.',
      values: {
        passion: 'Äkta Passion',
        safety: '100% Trygghet',
        planning: 'Personlig Rådgivning',
        quality: 'Kvalitet i varje detalj'
      }
    },
    planTripPage: {
      title: 'Planera din resa till Hurghada',
      subtitle: 'Skräddarsydd semesterrådgivning för familjer, par, grupper och ensamresenärer.',
      intro: 'Oavsett om ni vill ha lugna ö-turer med max 8 personer, ridtur på stranden, ökensafari, snabb speedbåt eller en stor privat båt för 20 personer, anpassar vi allt efter era önskemål.',
      optionsTitle: 'Vem reser du med?',
      requestOffer: 'Begär ett skräddarsytt erbjudande',
      families: 'Familjesemester',
      familiesDesc: 'Barnvänliga båtar, lugna snorkelplatser och avkopplande dagsutflykter med gott om plats.',
      familiesFeatures: [
        'Barnvänliga båtar med gott om skugga och solsängar',
        'Lugna snorkelplatser med flytvästar i alla barnstorlekar',
        'Flexibelt schema anpassat efter barnens rytm',
        'Möjlighet till privat hotelltransfer med bilbarnstolar'
      ],
      couples: 'Par & Romantik',
      couplesDesc: 'Privata speedbåtturer, ridturer i solnedgången och intima ö-besök.',
      couplesFeatures: [
        'Exklusiva privata båtturer bara för er två',
        'Romantisk lunch på däck med utsikt över turkost vatten',
        'Ostörd simning vid avskilda korallrev och sandbankar',
        'Solnedgångssegling med privat champagne och färsk frukt'
      ],
      groups: 'Grupper & Vänner',
      groupsDesc: 'Stor privat båt för upp till 20 personer, super ökensafari och fartfylld speedbåt till White Island.',
      groupsFeatures: [
        'Hyr hela båten för kompisgänget eller storfamiljen',
        'Kombinerade dagar med vattensport, snorkling och ökenfyrhjuling',
        'Skräddarsydd catering och musik ombord efter önskemål',
        'Privat minibussupphämtning direkt från hotellet'
      ],
      solo: 'Ensamresenärer',
      soloDesc: 'Trygga guidade turer med personlig support där du träffar andra trevliga resenärer.',
      soloFeatures: [
        'Skandinavisk/engelsktalande vägledning och varmt mottagande',
        'Små intima grupper med max 8-12 deltagare',
        'Möjlighet till privat certifierad PADI-instruktör',
        'Personliga rekommendationer för lokala restauranger och kultur'
      ]
    },
    experienceDetail: {
      back: 'Tillbaka till upplevelser',
      about: 'Om upplevelsen',
      highlights: 'Höjdpunkter & Inkluderat',
      photos: 'Bilder från turen',
      book: 'Boka din upplevelse',
      foundedBy: 'Grundat av Nicoline & Ziad',
      transferIncluded: 'Hotelltransfer ingår / avtalas direkt',
      personalSupport: 'Personlig support och rådgivning',
      noPrepayment: 'Ingen förskottsbetalning krävs',
      sendInquiry: 'Skicka förfrågan',
      writeInsta: 'Skriv på Instagram',
      contactInsta: 'Skriv på Instagram',
      questionsCall: 'Frågor? Ring oss på',
      notFound: 'Upplevelsen hittades inte',
      loading: 'Hämtar upplevelse...'
    },
    faqPage: {
      title: 'Vanliga Frågor och Svar',
      subtitle: 'Hitta snabba och tydliga svar på allt ni behöver veta före er resa till Hurghada. Har ni andra frågor är ni alltid välkomna att kontakta oss.',
      notFoundTitle: 'Hittade ni inte svaret på er fråga?',
      notFoundSub: 'Kontakta oss direkt på Instagram @captainhurgada eller via vårt kontaktformulär. Vi svarar snabbt!',
    },
    notFoundPage: {
      badge: 'Fel 404',
      title: 'Sidan Hittades Inte',
      message: 'Sidan ni letar efter finns tyvärr inte eller har flyttats.',
      homeBtn: 'Gå till startsidan',
      expBtn: 'Se upplevelser'
    },
    forbiddenPage: {
      badge: 'Fel 403',
      title: 'Åtkomst Nekad',
      message: 'Ni har inte behörighet att besöka denna sida på captainhurgadatours.dk.',
      homeBtn: 'Gå till startsidan'
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('cht_lang') || 'da';
  });

  const toggleLanguage = (newLang) => {
    const supported = ['da', 'en', 'de', 'no', 'sv'];
    if (supported.includes(newLang)) {
      setLang(newLang);
      localStorage.setItem('cht_lang', newLang);
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const keys = path.split('.');
    let current = translations[lang] || translations.da;
    for (const k of keys) {
      if (current && current[k] !== undefined) {
        current = current[k];
      } else {
        // Fallback to Danish
        let fallbackCurrent = translations.da;
        for (const fbK of keys) {
          if (fallbackCurrent && fallbackCurrent[fbK] !== undefined) {
            fallbackCurrent = fallbackCurrent[fbK];
          } else {
            return path;
          }
        }
        return fallbackCurrent;
      }
    }
    return current;
  };

  const getLocalized = (obj, fallback = '') => {
    if (!obj) return fallback;
    if (typeof obj === 'string') return obj;
    return obj[lang] || obj['da'] || obj['en'] || obj['de'] || obj['no'] || obj['sv'] || fallback;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang: toggleLanguage, t, getLocalized }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
